module.exports = __webpack_public_path__ + "media/img/illustrations/check-92ea93c4fcd0f36b97afd77523d67be4.svg";